import React, { useState } from 'react';
import axios from 'axios';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Email validation function
  const validateEmail = (email) => {
    const gmailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
    return gmailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Client-side email validation
    if (!validateEmail(email)) {
      setMessage('Please enter a valid Gmail address.');
      return;
    }

    setIsSubmitting(true);

    try {
      // Send the email to the backend
      const response = await axios.post('https://cottonlocalhost1365.onrender.com/api/subscribe', { email });

      // Display success message
      setMessage(response.data.message);
      setEmail(''); // Clear the input field
    } catch (error) {
      // Display user-friendly error messages
      if (error.response?.data?.message === 'Email already subscribed') {
        setMessage('You are already subscribed!');
      } else {
        setMessage('An error occurred. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 px-4">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1A2A3A] mb-8">Join Our Community</h2>
        <p className="text-lg md:text-xl mb-8">
          Stay updated with our latest products, promotions, and news by subscribing to our newsletter.
        </p>
        <form onSubmit={handleSubmit} className="flex justify-center">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="p-2 rounded-l-lg border border-gray-300 focus:outline-none"
            required
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="bg-[#1A2A3A] text-white p-2 rounded-r-lg hover:bg-indigo-600 transition duration-300 flex items-center justify-center"
          >
            {isSubmitting ? (
              <>
                {/* Loading spinner */}
                <svg className="animate-spin h-5 w-5 mr-2" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Subscribing...
              </>
            ) : (
              'Subscribe'
            )}
          </button>
        </form>
        {/* Display success or error message */}
        {message && (
          <p className={`mt-4 ${message.includes('successful') ? 'text-green-600' : 'text-red-600'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
};

export default NewsletterSection;